import { Schema } from "rsuite";

const { StringType } = Schema.Types;

export const UserFormSchema = Schema.Model({
  firstName: StringType().maxLength(30).isRequired(),
  lastName: StringType().maxLength(30).isRequired(),
  email: StringType()
    .maxLength(50)
    .isEmail("Must be a valid email")
    .isRequired(),
  phoneNumber: StringType().maxLength(20).isRequired(),
  department: StringType().isRequired(),
  companySKey: StringType().isRequired(),
  userName: StringType()
    .maxLength(20, "At most 20 characters")
    .isRequired("Username is a required field")
    .minLength(6, "At least 6 characters"),
});
